import IconButton from "@mui/material/IconButton";
import type { TogetherSession } from "../../../types";

// The global, outside-the-Together-screen recovery affordance - shown
// whenever togetherSession is active but the Lightbox isn't open (navigated
// away, or a session freshly discovered on boot/reconnect that hasn't been
// explicitly rejoined yet). Deliberately a compact single-row pill, not the
// full dock TogetherRoot.tsx renders on the actual Together screen - same
// fixed-position/dark-glass template as the schedule-reminder/incoming-
// invite banners it sits alongside (TogetherRoot.tsx), styled via the same
// shared dark-glass rule as .together-status-pill/.together-dock.
export function TogetherRejoinPill({
  session,
  partnerDisplayName,
  onRejoin,
  onEnd,
  rejoining,
  ending,
}: {
  session: TogetherSession;
  partnerDisplayName: string;
  onRejoin: () => void;
  onEnd: () => void;
  rejoining: boolean;
  ending: boolean;
}) {
  return (
    <div className="together-rejoin-pill" role="status">
      <button type="button" className="together-rejoin-pill-tap" onClick={onRejoin} disabled={rejoining}>
        <i className="bi bi-play-circle-fill" aria-hidden="true" />
        <span>
          <strong>Watch Together</strong>
          <span className="together-rejoin-pill-sub">
            {session.partnerConnected ? `Tap to rejoin with ${partnerDisplayName}` : `Waiting for ${partnerDisplayName}…`}
          </span>
        </span>
      </button>
      <IconButton aria-label="End Watch Together" size="small" onClick={onEnd} disabled={ending} sx={{ color: "inherit", flexShrink: 0 }}>
        <i className="bi bi-x-lg" aria-hidden="true" />
      </IconButton>
    </div>
  );
}
